import { toUpper, shrinkWordsWidth, isMobilePhone, isAndroidTablet, isMobileTablet, screenCanShowModal, doWhenReady, /* getComputedDomValue, simulate*/ } from '../../library/calc';
import { isDevelopment, iphoneBottomBar, sliderTopBar, isRtl } from '../../library/constants';

const maxLength = ( isMobilePhone() ? 35: 35);

export const addSources = ({pr_id, callback}) => {

        if(!isDevelopment){
          window.addSources(pr_id);
        }
        else{
          console.log('You are on Dev');
        }

        const whenMediaSelectorLoaded = () => {
          return document.getElementById('select_and_cite_modal') != null;
        }

        const adaptStylesCitationModal = () => {

          if(typeof(callback) === 'function' ) callback(); // Adapts style for desktop and tablets. resizePhotoUploadModalForDesktopAndTablets()

          if( isAndroidTablet()) {

            window.callCreateScrollableModal('select_and_cite_modal');

          }


          /* ************************************

            Below applies only to mobile phones.

           * ************************************/

          if( isAndroidTablet() || !isMobilePhone()) {
            return;
          }

          document.querySelector('#fact_container div').style.setProperty("width", `${window.innerWidth}px`, "important");

          if(isRtl){
            document.querySelector ('#fact_container div:nth-of-type(1)').style.setProperty("float", `left`, "important");
            document.querySelector ('#fact_container select').style.setProperty("float", `right`, "important");
            document.querySelector ('#fact_container span.tagged_only').style.setProperty("float", `right`, "important");
            document.querySelector ('#fact_container input[type="checkbox"]').style.setProperty("float", `right`, "important");
            document.querySelector ('#fact_container .info[data-icon]').style.setProperty("float", `right`, "important");
          }

          document.querySelector('#selected_document_update_panel').style.setProperty("width", `${window.innerWidth}px`, "important");
          document.querySelector('#add_new_document_button').style.setProperty("display", "none", "important");

          document.querySelector('#select_and_cite_modal').style.setProperty("opacity", 1);
          document.querySelector('.modal_lightbox').style.setProperty("width", "1000vw", "important");

        }

        doWhenReady({argument: '', condition: whenMediaSelectorLoaded, callback: adaptStylesCitationModal, attempts: {ongoing:0, end: 99999999}, fromWhere: ''})


        if(isRtl){

          const whenToolTipLoaded = () => {
            return document.querySelector('.t_Tooltip') != null;
          }

          const adaptStylesRTLToolTip = () => {
            document.querySelector ('.t_Tooltip').classList.add("rtl");
            const helpTipContent = document.querySelectorAll('.t_Tooltip .border-box.content[style="display:none;"]');
            helpTipContent.forEach((element)=>{
            console.log('poo3');
                element.style.setProperty("padding", `10px 17px 75px 70px`, "important");
            });
          }

          doWhenReady({argument: '', condition: whenToolTipLoaded, callback: adaptStylesRTLToolTip, attempts: {ongoing:0, end: 99999999}, fromWhere: ''})

        }

}

export const translateMenuItemActions = ( translatedLabels ) => {

  let translateMenuItemActionsArray = [
    { // index 0
      imgFile: `address-card.svg`,
      label: shrinkWordsWidth({word: toUpper(translatedLabels['view profile'].translatedLabel), maxLength}),
      permission: 'action_profile',
      action: (pr_id) => {
        const href = '/profile/index/' + pr_id;
        window.open(href, '_blank');
      },
      canSlideIn: false,
    },

    { // index 1
      imgFile: `addPhoto.svg`,
      label: shrinkWordsWidth({word: toUpper(translatedLabels['add photo'].translatedLabel), maxLength}),
      permission: 'action_add_photo',
      action: (pr_id, focus_pr_id, callback) => {

        // index 1  Global search this ... index === 1

        if(isDevelopment) { console.log('You are on Dev'); return;}

        window.addPhoto(
          pr_id, // highlight_pr_id -- this pr_id that we are uploading picture
          focus_pr_id // focus_pr_id -- bring tree back to focus node tree
        );

        const whenAddPhoto = () => {
          return document.getElementById('photo_uploader_thin') != null;
        }
        const adaptStylesPhotoUploadModal = () => {

          if(typeof(callback) === 'function' ) callback(); // Adapts style for desktop and tablets. resizePhotoUploadModalForDesktopAndTablets()

          if(isRtl) {

            const photo_uploader_thin = document.querySelector('#photo_uploader_thin');
            photo_uploader_thin.classList.add("rtl")

          }


          if( isAndroidTablet() || !isMobilePhone())  return;
          /*

            Only Mobile below

           */


          const albumListHeight = 16;
          const instructBar = document.querySelector('#header-thin-lightbox');
          const instructBarHeight = parseInt(window.getComputedStyle(instructBar).getPropertyValue('height'), 10);

          const tab = document.querySelector('#photo_uploader_thin #photo_tabs_thin_border .tabs_thin_border li');
          const tabHeight = parseInt(window.getComputedStyle(tab).getPropertyValue('height'), 10);
          const album_media = document.querySelector('.album_media');
          const  album_mediaHeight = window.innerHeight - albumListHeight - instructBarHeight -  tabHeight - sliderTopBar - iphoneBottomBar;

          album_media.style.height = `${ album_mediaHeight }px`

          if(!isMobileTablet()){
            const cancel = document.querySelector('#cancel-upload-button');
            cancel.parentNode.removeChild(cancel);
          }
          const h1 = document.querySelector('.fileinput-button h1');
          const messageUpload = (typeof(window.trl) !== 'undefined' ? window.trl('Touch icon to select files', 'Photo uploader'): 'Touch icon to select files')
          h1.innerHTML = messageUpload;
          document.querySelector('.fileinput-button h1').style.display = 'block';

        }

        doWhenReady({argument: '', condition: whenAddPhoto, callback: adaptStylesPhotoUploadModal, attempts: {ongoing:0, end: 99999999}, fromWhere: 'devAutoStart'})


      },
      close: () =>{
        window.active_panel.hide();
      },
      canSlideIn: true,
    },
    { // index 2
      imgFile: `delete.svg`,
      label: shrinkWordsWidth({word: toUpper(translatedLabels['delete'].translatedLabel), maxLength}),
      permission: 'action_delete',
      action: (pr_id) => {
        if(isDevelopment) { console.log('You are on Dev'); return;}

        window.deleteNode(pr_id);
      },
      close: () =>{
        window.deleteNodeMessage.close();
      }
    },
    { // index 3
      imgFile: `addFamily.svg`,
      label: shrinkWordsWidth({word: toUpper(translatedLabels['add family'].translatedLabel), maxLength}),
      permission: 'action_add_family',
      action: (pr_id) => {
        if(isDevelopment) { console.log('You are on Dev'); return;}
        window.addToFamily(pr_id);
      },
      close: () =>{
        window.active_panel.hide();
      },
      canSlideIn: true,
    },
    { // index 4
      imgFile: `removeFamily2.svg`,
      label: shrinkWordsWidth({word: toUpper(translatedLabels['remove family'].translatedLabel), maxLength}),
      permission: 'action_remove_family',
      action: (pr_id) => {
        if(isDevelopment) { console.log('You are on Dev'); return;}
        window.removeFromFamily(pr_id);
      },
      close: () =>{
        window.active_panel.hide();
      },
      canSlideIn: false,
    },
    { // index 5
      imgFile: `addCollaborator.svg`,
      label: shrinkWordsWidth({word: toUpper(translatedLabels['add collaborator'].translatedLabel), maxLength}),
      permission: 'action_add_collaborator',
      action: (pr_id) => {
        if(isDevelopment) { console.log('You are on Dev'); return;}
        window.addCollaborator(pr_id);
      },
      close: () =>{
        window.active_panel.hide();
      },
      canSlideIn: true,
    },
    { // index 6
      imgFile: `removeCollaborator.svg`,
      label: shrinkWordsWidth({word: toUpper(translatedLabels['remove collaborator'].translatedLabel), maxLength}),
      permission: 'action_remove_collaborator',
      action: (pr_id) => {
        if(isDevelopment) { console.log('You are on Dev'); return;}
        window.removeCollaborator(pr_id);
      },
      close: () =>{
        window.active_panel.hide();
      },
      canSlideIn: false,
    },
    { // index 7
      imgFile: `nophoto.svg`,
      label: shrinkWordsWidth({word: toUpper(translatedLabels['remove photo'].translatedLabel), maxLength}),
      permission: 'action_remove_photo',
      action: (pr_id) => {
        if(isDevelopment) { console.log('You are on Dev'); return;}
        window.removePhoto(pr_id);
      },
      close: () =>{
        window.active_panel.hide();
      },
      canSlideIn: false,
    },
    { // index 8
      imgFile: `sendMessage.svg`,
      label: shrinkWordsWidth({word: toUpper(translatedLabels['Send message'].translatedLabel), maxLength}),
      permission: 'action_send_message',
      action: (pr_id) => {
        if(isDevelopment) { console.log('You are on Dev'); return;}
        window.sendAMessage(pr_id);
      },
      close: () =>{
        window.active_panel.hide();
      },
      canSlideIn: true,
    },
    { // index 9
      imgFile: `mergemove.svg`,
      label: shrinkWordsWidth({word: toUpper(translatedLabels['Move Profile'].translatedLabel), maxLength}),
      permission: 'action_move',
      action: (pr_id, focus_pr_id, callback) => {
        callback();
      },
      close: () =>{

      },
      canSlideIn: false,
      // desktopOnly: true,
    },
    { // index 10
      imgFile: `curatorOptions.svg`,
      label: shrinkWordsWidth({word: toUpper(translatedLabels['curator options'].translatedLabel), maxLength}),
      permission: 'action_curator_options',
      action: (pr_id) => {
        if(isDevelopment) { console.log('You are on Dev'); return;}
        console.log('window.openCuratorOptions(' + pr_id + ')');
        window.openCuratorOptions(pr_id);
      },
      close: () =>{
        window.closeCuratorOptionsRedraw();
      },
      canSlideIn: true,
    },
    { // index 11
      imgFile: `addToProject.svg`,
      label: shrinkWordsWidth({word: toUpper(translatedLabels['add to projects'].translatedLabel), maxLength}),
      permission: 'action_add_to_project',
      action: (pr_id) => {
        if(isDevelopment) { console.log('You are on Dev'); return;}
        window.openProjectOptions(pr_id);
      },
      close: () =>{
        window.active_panel.hide();
      },
      canSlideIn: true,
    },


    /*,
    {
      imgFile: `resolveConflicts.svg`,
      label: `Resolve conflicts`,
      permission: 'action_resolve_conflicts',
      action: (pr_id) => {
        window.resolveConflicts(pr_id);
      }
    }*//*,
    {
      imgFile: `move.svg`,
      label: `Move`,
      permission: 'action_move',
      action: (pr_id) => {}
    },
    {
      imgFile: `resize.svg`,
      label: `Resize photo`,
      permission: 'action_resize_photo',
      action: (pr_id) => {}
    },
    {
      imgFile: `resolveDuplicates.svg`,
      label: `Resolve duplicates`,
      permission: 'action_resolve_duplicates',
      action: (pr_id) => {}
    },*/
  ];


  /*!isMobilePhone() && */translateMenuItemActionsArray.push(
    {  // index 12  Global search this ... index === 12
      imgFile: `document.svg`,
      label: shrinkWordsWidth({word: toUpper(translatedLabels['add sources'].translatedLabel), maxLength}),
      permission: 'action_add_sources',
      action: (pr_id, focus_pr_id, callback) => {
        // if( typeof(window.callResetLaunchedSourcesFromEditLink) !== 'undefined' ) window.callResetLaunchedSourcesFromEditLink(false)
        addSources({pr_id, callback});

      },
      close: () =>{
        // if( window.docLightbox ){ window.docLightbox.destroy();}
        document.querySelector('.panel_action').dispatchEvent(new MouseEvent('click', { bubbles: true }));
        window.callSlideOutMoreFormHide ('close add source form')
      },
      canSlideIn: true,
    }
  );

  !isMobilePhone() && translateMenuItemActionsArray.push(

    { // index 13  Global search this ... index === 13
      imgFile: `resolve_duplicates.svg`,
      label: shrinkWordsWidth({word: toUpper(translatedLabels['Resolve Duplicates'].translatedLabel), maxLength}),
      permission: 'action_resolve_duplicates',
      action: (pr_id, focus_pr_id, callback) => {
        callback();
      },
      close: () =>{

      },
      canSlideIn: true,
    }

  );
  return translateMenuItemActionsArray;
}
